import { Grid, LinearProgress, Typography } from "@material-ui/core";
import { Database, PencilLine, Trash } from "phosphor-react";
import React from "react";
import commonStyles from "../../../../../Utils/commonStyles";

const StorageOverview = () => {
  const commonClasses = commonStyles();
  return (
    <div
      style={{
        backgroundColor: "#252A38",
        borderRadius: "10px",
        padding: "10px",
        display: "flex",
        flexDirection: "column",
        gap: "6px",
      }}
    >
      <div className={commonClasses.flexBetween}>
        <div className={commonClasses.flexAndGap8Px}>
          <Database />
          <Typography>Storage Overview</Typography>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <PencilLine size={20} color="gray" />
          <Trash size={20} color="gray" />
        </div>
      </div>
      <div
        style={{
          backgroundColor: "#1F222E",
          padding: "6px",
          borderRadius: "10px",
        }}
      >
        <div
          className={commonClasses.flexBetween}
          style={{
            marginBottom: "4px",
          }}
        >
          <span>22.6 GB</span>
          <span>100 GB Total</span>
        </div>
        <LinearProgress variant="determinate" value={50} />
      </div>
      <div>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <div className={commonClasses.flexAndGap8Px}>
              <Database />
              <span>Assets</span>
            </div>
          </Grid>
          <Grid item md={8}>
            <div className={commonClasses.flexAndGap8Px}>
              <span style={{ width: "30%" }}>12.4 GB</span>
              <LinearProgress
                variant="determinate"
                value={50}
                style={{ width: "100%" }}
              />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <div className={commonClasses.flexAndGap8Px}>
              <Database />
              <span>Sequences</span>
            </div>
          </Grid>
          <Grid item md={8}>
            <div className={commonClasses.flexAndGap8Px}>
              <span style={{ width: "30%" }}>12.4 GB</span>
              <LinearProgress
                variant="determinate"
                value={50}
                style={{ width: "100%" }}
              />
            </div>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item md={4}>
            <div className={commonClasses.flexAndGap8Px}>
              <Database />
              <span>Others</span>
            </div>
          </Grid>
          <Grid item md={8}>
            <div className={commonClasses.flexAndGap8Px}>
              <span style={{ width: "30%" }}>12.4 GB</span>
              <LinearProgress
                variant="determinate"
                value={50}
                style={{
                  width: "100%",
                }}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default StorageOverview;
